<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <!-- <div class="page-top-wrap"> -->
            <div class="top wrap clear">
                <h2 class="bold  float-left">Untact 수업 환경 문의</h2><br>
            </div>
        <!-- </div> -->

        <div class="page-top-wrap-untact">
            <div class="untact-wrap">
                <div class="untact-title">
                    <div class="clear">
                        <span class="" v-if="info.state == 1">{{info.state_txt}}</span>
                        <span class="on" v-if="info.state == 2">{{info.state_txt}}</span>
                        <span class="complete" v-if="info.state == 3">{{info.state_txt}}</span>
                        <h1>{{info.title}} <img src="../assets/img/comment_icon.png" v-if="info.is_answer == true"/></h1>
                        <p>{{info.cratedate}}</p>
                    </div>

                </div>
                <div class="untact-file" v-if="info.isupfile == true">
                    <div>
                        <a href="#" onclick="return false;" @click="download(info.upfilelink)"><img src="../assets/img/file-download.png" class="mr-10" />{{info.upfilename}}</a>
                    </div>
                </div>
                <div class="untact-body">
                    <div>
                        {{info.contents}}
                        <!-- <p v-model="info.contents"></p> -->
                        <!-- <span class="bold">Strong points</span>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type</p>

                        <span class="bold">Weak points</span>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type</p>

                        <span class="bold">Next action plans</span>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type</p> -->
                    </div>
                    <div class="untact-btn clear mt-20" v-if="uidx == info.idx_member && info.state == 1">
                        <button class="ml-10" @click="doUpdate(info.idx)">수정</button>
                        <button class="delete" @click="doDelete(info.idx)">삭제</button>
                    </div>
                </div>
            </div>
            <div class="comment-wrap" v-if="answer.length > 0">
                <div class="comment-top">
                    <p class="font-14">답변</p>
                </div>
                <div class="comment-itmes">
                    <ul>
                        <li class="clear" v-for="(item,index) in answer" :key="index">
                            <div class="item-left">
                                <span class="bold com-writer">{{item.englishname}}</span>
                                <span class="btn-point">매니저</span>
                                <span class="com-date">{{item.createdate}}</span>
                            </div>
                            <p>{{item.contents}}</p>
                            <div v-if="item.upfilename != ''">
                                <a href="#" onclick="return false;" @click="download(item.upfilelink)"><img src="../assets/img/file-download.png" class="mr-10" />{{item.upfilename}}</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="untact-bottom-btn clear">
                <button class="list btn-base-white float-left" @click="goList()">목록</button>
                <button class="list btn-base-white float-right ml-10" v-if="info.next_sn != null" @click="nextBtn(info.next_sn)"><span><img src="../assets/img/arrow-down.png" /></span>&nbsp;&nbsp;다음글</button>
                <button class="list btn-base-white float-right" v-if="info.prev_sn != null" @click="prevBtn(info.prev_sn)"><span><img src="../assets/img/arrow-top.png" /></span>&nbsp;&nbsp;이전글</button>
            </div>
        </div>

    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'UntactView',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        q_idx : "",
        info:{},answer:[],
        uidx:localStorage.getItem("uidx"),
        host:"" 
    }),
    created() {
         if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    mounted() {
        //    this.doc_del_rendar();
        this.q_idx = this.$route.query.q_idx;
        this.host = "stagehq.carrotenglish.net";
        this.initPage();
    },
    methods: {
        doDelete(q_idx){
            if(confirm("정말로 문의사항을 삭제하시겠습니까?") == true){
                var me = this;
                var params = {
                    uidx:me.uidx,
                    q_idx:q_idx
                }
                this.axios.get(this.$store.state.host + "/rest/mobile/UntactQnaDelete/",{
                    params:params
                }).then(function(res){
                    // console.log(res);
                    if(res.data.err == 0){
                        alert("삭제 되었습니다.");
                        location.href="/untacttest";
                    }else{
                        alert(res.data.err_msg);
                    }
                });
            }
        },
        nextBtn(next_sn) {
            location.href = "/untactview?q_idx=" + next_sn;
        },
        prevBtn(prev_sn) {
            location.href = "/untactview?q_idx=" + prev_sn;
        },
       initPage(){
           var me = this;
           var params = {
               q_idx : this.q_idx,
               u_idx : localStorage.getItem("uidx")
           }
           console.log(me.info);
           this.axios.get(this.$store.state.host + "/rest/mobile/UntactQnaView",{
               params:params
           }).then(function(res){
            //    console.log(res);
                if(res.data.info.err == 0){
                    me.info = res.data.info;
                    me.answer = res.data.answer.list;
                    if(me.answer[0].upfilename == null){
                        me.answer[0].upfilename = "";
                    }
                    console.log(me.answer);
                }else{
                    alert(res.data.err_msg);
                }
           });
       },
       goList() {
            location.href = "/untacttest";
        },
        doUpdate(q_idx) {
            location.href = "/untactmodfiy?q_idx=" + q_idx;
        },
        download(url){
            var host = "";
            if(location.hostname == "stagest.carrotenglish.net"){
                host = "https://stagestapi.carrotenglish.net";
            }else if(location.hostname == "st.carrotenglish.net"){
                host = "https://stapi.carrotenglish.net/";
            }else if(location.hostname == "student.carrotenglish.net"){
            host = "https://stapi.carrotenglish.net/";
            }else if(location.hostname == "m.carrotenglish.net"){
            host = "https://stapi.carrotenglish.net/";
        }else{
                host = "https//hq.test.co.kr";
            }
            location.href=host + 'download?filepath='+url+"&tp=MEMBER";
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }

    // .page-top-wrap {
    //     width: 100%;
    //     border-bottom: 10px solid #F5F5F5;

        .top {
            // padding-right: 20px;
            border-bottom: 10px solid #f5f5f5;;
            padding-bottom: 17px;
            padding-top: 70px;
            background: url("../assets/img/top-bg.png") no-repeat right -80px;
            background-size: 300px;
            position: relative;

            .my-reason {
                position: absolute;
                right: 0;
                bottom: 15%;
            }

            p {
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                margin-top: 20px;
            }

            div {
                select {
                    border: 1px solid var(--unnamed-color-53caff);
                    background: #FFFFFF 0% 0% no-repeat padding-box;
                    border: 1px solid #53CAFF;
                    border-radius: 4px;
                    opacity: 1;
                    color: #53CAFF;
                    ;
                }
            }
        // }
        .wrap {
            width: 100%;
            max-width: none;
        }
    }

    .page-top {
        border-bottom: 1px solid #E9E9E9;

        .review-top {

            div {
                background: #F5F5F5 0% 0% no-repeat padding-box;
                border: 1px solid #E9E9E9;
                border-radius: 10px;
                opacity: 1;
                width: 95%;
                margin: 0 auto;
                box-sizing: border-box;
                padding-top: 19px;
                padding-bottom: 19px;

                p {
                    float: left;
                    text-align: center;

                    &:first-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }

                    &:last-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .page-top-wrap-untact {
        width: 90%;
        max-width: 700px;
        padding-bottom: 20px;
        margin: 0 auto;
        .none-untact {
            display: table;
            min-height: 300px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }

        .untact-wrap {
            .untact-title {
                padding-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px dashed #E9E9E9;

                div {
                    position: relative;
                    width: 90%;
                    margin: 0 auto;

                    span {
                        background: #F5F5F5 0% 0% no-repeat padding-box;
                        border-radius: 12px;
                        font-size: 12px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                        font-weight: bold;
                        padding-left: 10px;
                        padding-right: 10px;
                        float: left;
                    }

                    span.on {
                        color: #53CAFF;
                    }

                    span.complete {
                        background: #53CAFF 0% 0% no-repeat padding-box;
                        border-radius: 12px;
                        font-size: 12px;
                        font-weight: bold;
                        letter-spacing: 0px;
                        color: #FFFFFF;
                        opacity: 1;
                    }

                    h1 {
                        float: left;
                        width: 80%;
                        font-size: 16px;
                        font-weight: bold;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                        padding-left: 30px;
                        img{
                            width: 15px;
                        }
                    }

                    p {
                        position: absolute;
                        right: 0;
                        top: 0;
                        font-size: 11px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }
                }
            }

            .untact-file {
                width: 100%;
                border-bottom: 1px dashed #E9E9E9;
                padding-top: 20px;
                padding-bottom: 20px;

                div {
                    width: 90%;
                    margin: 0 auto;

                    a {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #53CAFF;
                        opacity: 1;
                    }
                }
            }

            .untact-body {
                width: 100%;
                padding-top: 10px;
                // border-bottom: 1px dashed #E9E9E9;
                padding-bottom: 10px;
                div {
                    width: 90%;
                    margin: 0 auto;
                    word-break: break-word;
                    span {
                        display: block;
                        padding-top: 25px;
                    }

                    p {
                        text-align: left;
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                    }
                }

                .untact-btn {
                    button {
                        border: 0px solid #B7B7B7;
                        border-radius: 3px;
                        opacity: 1;
                        padding: 5px 0px;
                        font-size: 14px;
                        background: white;
                        float: right;
                    }

                    .delete {
                        border: 0px solid #FF0000;
                        color: #000;
                    }
                }
            }
        }

        .comment-wrap {
            // margin-top: 30px;
            // background: #F5F5F5 0% 0% no-repeat padding-box;
            padding-top: 10px;
            padding-bottom: 30px;
            border-top: 10px solid #f5f5f5;
            .comment-top{
                width: 90%;
                margin: 0 auto;
                border-bottom: 2px solid #f5f5f5;
                padding-bottom: 10px;
            }
            ul {
                li {
                    padding-top: 20px;
                    width: 90%;
                    margin: 0 auto;
                    border-bottom: 1px dashed #E9E9E9;
                    padding-bottom: 20px;

                    .item-left {
                        .com-writer {
                            font-size: 14px;
                            letter-spacing: 0px;
                            color: #000000;
                            opacity: 1;
                        }

                        .com-date {
                            font-size: 11px;
                            letter-spacing: 0px;
                            color: #B7B7B7;
                            opacity: 1;
                            margin-left: 10px;
                        }

                        .com-gubun {
                            background: #FFFFFF 0% 0% no-repeat padding-box;
                            border-radius: 12px;
                            font-size: 12px;
                            font-weight: bold;
                            letter-spacing: 0px;
                            color: #53CAFF;
                            opacity: 1;
                            padding-left: 11px;
                            padding-right: 11px;
                            margin-left: 10px;
                            box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
                            -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
                            -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
                        }
                    }

                    p {
                        text-align: left;
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                    }

                    div {
                        width: 100%;
                        margin: 0 auto;
                        padding-top: 10px;
                        a {
                            font-size: 14px;
                            letter-spacing: 0px;
                            color: #53CAFF;
                            opacity: 1;
                        }
                    }

                }

                &:last-child {
                    border-bottom: 0px;
                }
            }

            .comment-add {
                .wrap {
                    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
                    border: 1px solid var(--unnamed-color-b7b7b7);
                    background: #FFFFFF 0% 0% no-repeat padding-box;
                    border: 1px solid #B7B7B7;
                    opacity: 1;
                    position: relative;

                    textarea {
                        width: 100%;
                        resize: none;
                        border: 0px;
                        height: 100px;
                    }

                    button {
                        position: absolute;
                        right: 10px;
                        bottom: 10px;
                        background: #53CAFF 0% 0% no-repeat padding-box;
                        border: none;
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #FFFFFF;
                        opacity: 1;
                    }
                }

            }
        }

        .untact-bottom-btn {
            width: 90%;
            margin: 0 auto;
            padding-top: 20px;
        }
    }
}

.btn-base-white {
    padding: 5px;
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class{
        width: 100%;
        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;
            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }
        }
        .page-top-wrap-untact{
            width: 100%;
            .wrap {
                width: 90%;
                max-width: none;
            }
        }
    }
}
</style>
